import React from 'react'

import Header from '../components/public/shared/Header'
import Footer from '../components/public/shared/Footer'
import { isAuthenticated } from '../utils/auth'
import Link from 'next/link'

const basePath = process.env.BASE_PATH

interface JoinUsProps {
	authenticated: boolean
}

export const getServerSideProps = (ctx) => {
	return {
		props: {
			authenticated: isAuthenticated(ctx),
			title: 'Join us',
			description:
				'Master Challenge is growing fast. Join us in our mission to bridge the gap between university and industry.',
			url: `${basePath}/join-us`,
			image: 'join_us.png',
		},
	}
}

const vacancies = [
	// {
	// 	title: 'Company Recruiter',
	// 	period: '4-12 hours a week',
	// 	type: 'Freelance / Remote',
	// 	link: 'https://spodix.nl/vacature/Master%20Challenge/8c25e044-224a-472d-85d4-b6b02569b3f6',
	// }
]

// Port in to using useState hooks, if you need state
class JoinUs extends React.Component<JoinUsProps> {
	constructor(props: any) {
		super(props)
	}

	render() {
		const { authenticated } = this.props

		return (
			<div className="wrapper">
				<Header authenticated={authenticated} />
				<main className="pt-20 relative z-20">
					<div className="relative py-10">
						<div className="container mx-auto px-4 relative z-10">
							<div className="w-full max-w-2xl mx-auto text-center mt-4">
								<h1 className="text-3xl md:text-4xl mb-4 font-sans font-bold">
									Join us in our mission to bridge the gap between university
									and industry
								</h1>
								<p className="text-lg text-center">
									Master Challenge is growing fast. We are always interested in
									talking to like-minded and entrepreneurial people. See below
									for our job openings.
								</p>
							</div>
						</div>
					</div>

					{vacancies.length > 0 && (
						<div className="relative z-10 bg-gradient-to-b from-gray-50 mb-32 border-t ">
							<div className="container mx-auto lg:max-w-3xl px-4 md:px-8 relative">
								<div className="relative  mx-auto leading-relaxed p-8">
									<h3 className="text-3xl text-center mb-4 font-sans font-bold">
										Open positions
									</h3>

									<ul className="text-left border rounded-lg">
										{vacancies.map((vacancy, index) => {
											return (
												<li key={index}>
													<a
														href={vacancy.link}
														target="_blank"
														className="p-6 flex flex-wrap bg-wite shadow-none transition-shadow duration-300 items-center py-3 w-full hover:shadow"
														rel="noreferrer"
													>
														<div className="mr-3">
															<h4 className="font-bold text-lg">
																{vacancy.title}
															</h4>
															<span className="text-gray-800">
																{vacancy.type} -{' '}
																<span className="text-purple-800 font-semibold">
																	{vacancy.period}
																</span>
															</span>
														</div>
														<div className="button md:ml-auto bg-yellow-300 text-black hover:bg-yellow-200 duration-300 transition-colors my-2">
															Info &amp; apply
														</div>
													</a>
												</li>
											)
										})}
									</ul>
								</div>
							</div>
						</div>
					)}
					{vacancies.length == 0 && (
						<div className="relative z-10 bg-gradient-to-b from-gray-50 mb-32 border-t ">
							<div className="container mx-auto lg:max-w-3xl px-4 md:px-8 relative">
								<div className="relative mx-auto leading-relaxed p-8 pt-12">
									<h3 className="text-3xl text-center mb-4 font-sans font-bold">
										Currently no open positions.
									</h3>
									<p className="text-lg font-sans text-center">
										Stay up to date and{' '}
										<Link href="/contact">
											<a className="text-purple-900 font-bold hover:text-blue-600">
												contact us
											</a>
										</Link>{' '}
										if you’re interested in what we’re doing
									</p>
								</div>
							</div>
						</div>
					)}
				</main>
				<Footer />
			</div>
		)
	}
}

export default JoinUs
